import { render } from "./cabecalho.vue?vue&type=template&id=79b201ad"
import script from "./cabecalho.vue?vue&type=script&lang=js"
export * from "./cabecalho.vue?vue&type=script&lang=js"

import "./cabecalho.vue?vue&type=style&index=0&id=79b201ad&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__